/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styled from '@mui/styled-engine';
import IOSSwitch from '@/components/IosSwitch';
import { format } from 'date-fns';
import vi from 'date-fns/locale/vi';
import en from 'date-fns/locale/en-US';

import Image from '../Image';
import {
  Caption,
  Headline,
} from '../index';
import { Stack } from '@mui/material';

export const Capitalize = (str: string) => (str ? str.toLowerCase().replace(/(^|\s)[a-zàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđð]/gi, (c: string) => c.toUpperCase()) : '');

const tripDateIcon = 'https://storage.googleapis.com/fe-production/svgIcon/event_vex_blue_24dp.svg';

const Container = styled('div')`
  display: flex;
  flex-direction: row;

  .icon-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 16px;
  }

  .departure-date-select {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 64px;
    justify-content: center;
  }
`;

const DateInputSt = styled('div')`
`;

const DateInput = ({
  openCalendar,
  toggleReturn,
  isReturn,
  label,
  placeholder,
  value,
  dateFormat,
  onOpenCalendar,
  className = '',
  isDrawer,
  chooseReturn,
  lang,
  switchUpdateSecondTime,
  isTrain,
}: any) => (
  <Container className={`date-input-container ${className}`}>
    {!isDrawer && (
      <div className="icon-container">
        <Image
          imageSrc={tripDateIcon}
          alt="trip-date-icon"
          className="trip-date-icon"
          imageProps={{
            width: 24,
            height: 24,
          }}
        />
      </div>
    )}

    <div
      className="departure-date-select"
    >
      {value
        ? (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
            >
              <DateInputSt onClick={() => {
                if (switchUpdateSecondTime) {
                  switchUpdateSecondTime();
                }
                openCalendar(isReturn);
              }}
              >
                <Caption className="color--medium-sub">
                  {label}
                </Caption>
                <Headline
                  className="color--darkness"
                >
                  {format(new Date(value || ''), dateFormat, { locale: lang?.lang === 'en' ? en : vi })}
                </Headline>
              </DateInputSt>
              {!isReturn && (
                <Stack
                  direction="column"
                  justifyContent="space-between"
                  sx={{
                    paddingRight: '16px',
                  }}
                >
                  <Caption
                    className="color--medium-sub"
                  >
                    {lang?.SearchBar?.flightsTab?.roundTrip || 'Khứ hồi'}
                  </Caption>
                  <IOSSwitch
                    onChange={(valueInput: any) => toggleReturn(valueInput?.target?.checked)}
                    checked={chooseReturn}
                  />

                </Stack>
              )}
            </Stack>
          </>
        )
        : (
          <Headline
            className="color--medium-sub"
            onClick={() => openCalendar(isReturn)}
          >
            {placeholder || label}
          </Headline>
        )}
    </div>
  </Container>
);
export default DateInput;
